import React from "react";
import "../../assets/css/imageModal.css";

function ImageModal({ photo, onClose }) {

    if (!photo) return null;

    return (

        <div
            className="image-modal-overlay"
            onClick={onClose}
        >

            <div
                className="image-modal-container"
                onClick={(e) => e.stopPropagation()}
            >

                <div className="image-modal-wrapper">

                    <button
                        className="image-modal-close"
                        onClick={onClose}
                    >
                        ✕
                    </button>

                    <img
                        src={photo.imageUrl}
                        alt={photo.title}
                        className="image-modal-img"
                    />

                </div>

                <div className="image-modal-info">

                    <h2>{photo.title}</h2>

                    <p>{photo.category}</p>

                </div>

            </div>

        </div>

    );

}

export default ImageModal;